exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content{max-width:700px}@media only screen and (max-width:500px){.aio-body{padding:25px 20px!important}}", ""]);

// exports
